import { prepareEvent, isLeft } from '../RenderUtils';

export const addEvents = (element, action, SendAction) => {
  if (action.hold) {
    element.addEventListener(
      'touchstart',
      (e) => {
        prepareEvent(e);
        if (e.changedTouches.length === 1) SendAction(action.name, 'down');
      },
      true,
    );
    element.addEventListener(
      'mousedown',
      (e) => {
        prepareEvent(e);
        if (isLeft(e)) SendAction(action.name, 'down');
      },
      true,
    );
    element.addEventListener('touchend', (e) => {
      prepareEvent(e);
      SendAction(action.name, 'up');
    });
    window.addEventListener('mouseup', (e) => {
      prepareEvent(e);
      if (isLeft(e)) SendAction(action.name, 'up');
    });
  } else {
    element.addEventListener(
      'click',
      (e) => {
        prepareEvent(e);
        SendAction(action.name, 'click');
      },
      false,
    );
  }
};
